/**
 * useTemplateStatusMap
 * --------------------
 * TREATX-11C-ADMIN-TEMPLATE-EDITOR-INLINE-INDICATORS-01 (2026-06-15)
 *
 * Fetches the canonical Notification Admin endpoint
 *   GET /api/admin/notifications/template-status
 * and memoises the response as a map keyed by `event_key`.
 *
 * Reuses the existing endpoint introduced in
 * TREATX-NOTIFICATION-ADMIN-OPS-11B. Does NOT introduce any new
 * notification/template SSOT, service, endpoint, projection, cache or
 * worker. Read-only client side.
 */
import { useEffect, useState, useCallback } from 'react';
import api from '../utils/api';

export default function useTemplateStatusMap() {
  const [map, setMap] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/admin/notifications/template-status');
      const items = (r.data && r.data.items) || [];
      const next = {};
      items.forEach((row) => {
        if (row && row.event_key) {
          next[row.event_key] = row;
        }
      });
      setMap(next);
      setLoaded(true);
      setError(null);
    } catch (e) {
      // The canonical fallback (inline copy) keeps the editor usable
      // even when the operator does not have reporting.view permission.
      setMap({});
      setLoaded(true);
      setError(e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { statusByEventKey: map, loaded, error, refresh };
}
